var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import classNames from "classnames";
import React, { useCallback, useState, useEffect } from "react";
import { isTouchDevice } from "@riseart/fe-utils";
import { MenuItem } from "../item/Item";
import { MenuHorizontalSubmenu } from "./Submenu";
import { menuHorizontalItemCls, menuHorizontalItemClickableCls, menuHorizontalItemActiveCls, menuHorizontalItemWrapperCls } from "./Menu.less";
function MenuHorizontalItem(_ref) {
  var index = _ref.index, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$clickable = _ref.clickable, clickable = _ref$clickable === void 0 ? false : _ref$clickable, _ref$active = _ref.active, active = _ref$active === void 0 ? false : _ref$active, _ref$opened = _ref.opened, opened = _ref$opened === void 0 ? false : _ref$opened, _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, _ref$itemProps = _ref.itemProps, itemProps = _ref$itemProps === void 0 ? null : _ref$itemProps, _ref$itemComponent = _ref.itemComponent, itemComponent = _ref$itemComponent === void 0 ? null : _ref$itemComponent, _ref$submenuContent = _ref.submenuContent, submenuContent = _ref$submenuContent === void 0 ? null : _ref$submenuContent, _ref$items = _ref.items, items = _ref$items === void 0 ? null : _ref$items, _ref$position = _ref.position, position = _ref$position === void 0 ? null : _ref$position, onActiveItem = _ref.onActiveItem;
  var IS_TOUCH_DEVICE = isTouchDevice();
  var _useState = useState(0), _useState2 = _slicedToArray(_useState, 2), clickCount = _useState2[0], setClickCount = _useState2[1];
  var detailProps = {
    index,
    hasChildren: !!children,
    clickable,
    active,
    opened,
    className,
    itemProps,
    itemComponent,
    submenuContent,
    items
  };
  useEffect(function() {
    if (!opened) {
      setClickCount(0);
    }
  }, [opened]);
  var handleMouseEnter = useCallback(function(itemOptions) {
    return function(e) {
      e && e.preventDefault();
      onActiveItem(itemOptions, "mouseenter");
    };
  }, [onActiveItem]);
  var handleMouseLeave = useCallback(function(itemOptions) {
    return function(e) {
      e && e.preventDefault();
      onActiveItem(itemOptions, "mouseleave");
    };
  }, [onActiveItem]);
  var handleClick = useCallback(function(itemOptions) {
    return function(e) {
      if (IS_TOUCH_DEVICE && clickCount < 1) {
        setClickCount(clickCount + 1);
        e && e.preventDefault();
      }
      if (clickable || IS_TOUCH_DEVICE) {
        onActiveItem(itemOptions, "click");
      }
    };
  }, [onActiveItem, clickable, clickCount, IS_TOUCH_DEVICE]);
  var handleClose = useCallback(function(itemOptions) {
    return function() {
      onActiveItem(itemOptions, "close");
    };
  }, [onActiveItem]);
  var isItemActive = (clickable || IS_TOUCH_DEVICE) && active || active || opened;
  return /* @__PURE__ */ React.createElement("li", _extends({
    className: classNames(menuHorizontalItemCls, (clickable || IS_TOUCH_DEVICE) && menuHorizontalItemClickableCls, isItemActive && menuHorizontalItemActiveCls, className)
  }, !clickable && !IS_TOUCH_DEVICE ? {
    onMouseEnter: handleMouseEnter(detailProps),
    onMouseLeave: handleMouseLeave(detailProps)
  } : null), children || /* @__PURE__ */ React.createElement(React.Fragment, null, itemProps && !itemComponent ? /* @__PURE__ */ React.createElement(MenuItem, _extends({
    opened: isItemActive
  }, itemProps, {
    onClick: handleClick(detailProps)
  })) : null, !itemProps && itemComponent ? /* @__PURE__ */ React.createElement("div", {
    className: menuHorizontalItemWrapperCls,
    onClick: handleClick(detailProps)
  }, itemComponent) : null, items && items.length ? /* @__PURE__ */ React.createElement(MenuHorizontalSubmenu, _extends({
    clickable,
    onClose: handleClose,
    position,
    opened: isItemActive
  }, clickable || IS_TOUCH_DEVICE ? {
    onClose: handleClose(detailProps)
  } : null, {
    items
  })) : null, submenuContent && isItemActive ? /* @__PURE__ */ React.createElement(MenuHorizontalSubmenu, _extends({
    clickable,
    onClose: handleClose,
    opened: isItemActive
  }, clickable || IS_TOUCH_DEVICE ? {
    onClose: handleClose(detailProps)
  } : null), submenuContent) : null));
}
__name(MenuHorizontalItem, "MenuHorizontalItem");
export {
  MenuHorizontalItem
};
